import { baseUrlAtom } from "@/store/base_api";
import * as Sentry from "@sentry/react";
import { getDefaultStore } from "jotai";

export function initSentry() {
	const baseUrl = getDefaultStore().get(baseUrlAtom);
	const sentryOptions: Sentry.BrowserOptions = {
		release: import.meta.env.VITE_SENTRY_APP_RELEASE,
		dsn: import.meta.env.VITE_APP_SENTRY_DSN,
		environment: import.meta.env.VITE_APP_ENVIRONMENT,
		integrations: [
			Sentry.extraErrorDataIntegration(),
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: true,
				blockAllMedia: true,
			}),
		],
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		tracePropagationTargets: [baseUrl], // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
		ignoreErrors: [
			// These are too generic errors that are not useful to track, they are from any canceled request, but could be CORS also, but we can't know for sure
			"TypeError: Failed to fetch",
			"TypeError: NetworkError when attempting to fetch resource.",
		],
	};

	if (import.meta.env.DEV) {
		if (Array.isArray(sentryOptions.integrations))
			sentryOptions.integrations.push(Sentry.debugIntegration()); // console.log Sentry events
		sentryOptions.transport = (options) => {
			return Sentry.makeFetchTransport(
				options,
				async (_url, _init) => new Response(), // don't send request, just return a response
			);
		};
	}

	Sentry.init(sentryOptions);
}

// export const sentryLoginEffect = atomEffect((get) => {
//   const currentUser = get(currentUserAtom);
//   const sentryUser = currentUser && {
//     id: currentUser.identity_user_id,
//     username: currentUser.username,
//   };
//   Sentry.setUser(sentryUser);
// });
// sentryLoginEffect.debugLabel = "sentryLoginEffect";

// // A function that extracts the component name from a component stack trace inside a Sentry error object
// export function parseComponentStack(componentStack: string) {
//   const componentStackLines = componentStack.split("\n");
//   const componentLine = componentStackLines.find((line) =>
//     line.includes(" at ")
//   );
//   if (!componentLine) return "";
//   const componentName = componentLine.split(" at ")[1].trim();
//   return componentName;
// }
